import React from "react";

export default function MasterCardIcon() {
  return (
    <svg
      width="46"
      height="22"
      viewBox="0 0 46 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5009 16.5738C22.1838 17.4662 20.5119 18 18.6923 18C14.444 18 11 15.0899 11 11.5C11 7.91015 14.444 5 18.6923 5C20.5119 5 22.1838 5.53383 23.5009 6.42625C24.818 5.53383 26.49 5 28.3095 5C32.5578 5 36.0018 7.91015 36.0018 11.5C36.0018 15.0899 32.5578 18 28.3095 18C26.49 18 24.818 17.4662 23.5009 16.5738Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 16.5738C25.2581 15.3825 26.3837 13.5523 26.3837 11.5C26.3837 9.44766 25.2581 7.61749 23.5 6.42625C24.8171 5.53383 26.4891 5 28.3086 5C32.5569 5 36.0009 7.91015 36.0009 11.5C36.0009 15.0899 32.5569 18 28.3086 18C26.4891 18 24.8171 17.4662 23.5 16.5738Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5012 16.4552C25.2657 15.2629 26.3852 13.4852 26.3852 11.4996C26.3852 9.51392 25.2657 7.73622 23.5012 6.54395C21.7367 7.73622 20.6172 9.51392 20.6172 11.4996C20.6172 13.4852 21.7367 15.2629 23.5012 16.4552Z"
        fill="#FF5E00"
      />
    </svg>
  );
}
